import { Box, Stack, Drawer, Divider, IconButton, Typography, Alert, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { toast } from 'react-toastify';
import { eventList, glb_sv, sendRequest, serviceList } from 'src/utils';
import moment from 'moment';
import crypt from 'src/utils/service/crypt';
import { closestIndexTo } from 'date-fns';
import NotificationWarnLocationDeviceModal from 'src/components/modal/NotificationWarnLocationDeviceModal';
import Loader from 'src/components/loader/loader';
import TextInput from 'src/components/Input/TextInput';
import ConfirmDeviceModal from 'src/components/modal/ConfirmDeviceModal';
import NumberInput from 'src/components/Input/NumberInput';
import ChessBoard from 'src/components/ChessBoard/ChessBoard';
import ButtonAction from 'src/components/Button.js/SaveButton';
import Iconify from 'src/components/iconify';

export default function DrawerSidebar({
    setOpen,
    getData,
    device = {},
    bussiness,
    noteDeviceRequests,
    idDeviceRequests,
    open,
}) {
    const { t } = useTranslation();
    const [actionDeviceOnline, setActionDeviceOnline] = useState(false);
    const actionRef = useRef();
    const [visibleConfirm, setVisibleConfirm] = useState(false);
    const [note, setNote] = useState(noteDeviceRequests);
    const [dayGive, setDayGive] = useState('');
    const [isOpen, setIsOpen] = useState(false);
    const chekcRef = useRef(false);
    const [isChecked, setIsChecked] = useState(false);

    const openRef = useRef(false);

    const userRef = useRef(null);

    const [sendEmail, setSendEmail] = useState(false);
    const sendEmailRef = useRef();

    const [isOpenNotification, setIsOpenNotification] = useState(false);
    const [dataNotification, setDataNotification] = useState({});
    const [flagActionDevice, setFlagActionDevice] = useState(false);
    const flagActionDeviceRef = useRef(false);
    useMemo(() => {
        try {
            userRef.current = JSON.parse(crypt.deCode(sessionStorage.getItem('proc_data')));
        } catch (error) {}
    }, []);

    useEffect(() => {
        setNote(noteDeviceRequests);
        setFlagActionDevice(false)
        setIsOpenNotification(false)
        chekcRef.current =false
        openRef.current = false;
        sendEmailRef.current = false;
        setIsOpen(false)
        actionRef.current = false;
        setIsChecked(false)
        setVisibleConfirm(false)
        setActionDeviceOnline(false)
        
        return () => {
            clearIntervalCheckStatusCell();
        };
    }, [device,open]);

    // region openCell
    const openCell = (data) => {
        try {
            if (isChecked) return toast.error(t('system_statistical') + ', ' + t('not_action_transaction'));
            if (actionRef.current) return;
            setActionDeviceOnline(true);
            actionRef.current = true;

            if (!data) {
                console.error('data null', data);
                return;
            }

            if (!data.cell_lc) {
                console.error('cell_lc null', data);
                return;
            }

            let service = serviceList.openCellIOT;
            let inpuVal = [data.cabinet_cd, data.drawer_lc, data.cell_lc.row, data.cell_lc.column];
            if (data?.cabinet_type !== 'round') {
                service = serviceList.openCellIOT;
                inpuVal = [data.cabinet_cd, data.drawer_lc, data.cell_lc.row, data.cell_lc.column];
            } else {
                service = serviceList.openCellIOTCabinetV2;
                inpuVal = [data.cabinet_cd, data.drawer_lc, data.cell_lc.column, data.column];
            }
            // openRef.current = true;
            // handleActionDevice();
            sendRequest(service, inpuVal, openCellResult, true, timeOutFunctIOT, 15000, 0);
        } catch (error) {
            console.error('getDataResult error:', error, 'raw data:', data);
        }
    };
    useEffect(() => {
        setTimeout(() => {
            checkStaticticalChecking();
        }, 1000);
        if (openRef.current) {
            window.addEventListener('beforeunload', handleBeforeUnload);
            window.addEventListener('unload', handleBeforeUnload);
        }
        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
            window.removeEventListener('unload', handleBeforeUnload);
        };
    }, []);

    // region checkStaticticalChecking
    // check kiem ke
    const checkStaticticalChecking = useCallback(() => {
        if (chekcRef.current) {
            return;
        }
        chekcRef.current = true;
        const InVal = [1];
        sendRequest(
            serviceList.checkStatisticChecking,
            InVal,
            checkStaticticalCheckingResult,
            true,
            timeOutFunctcheckStaticticalChecking,
            15000
        );
    }, []);

    // region checkStaticticalCheckingResult
    const checkStaticticalCheckingResult = (reqInfoMap, message) => {
        chekcRef.current = false;
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            return;
        } else {
            setIsChecked(message.proc_data.rows[0].o_1[0].check_inv_status === '0' ? true : false);
        }
    };

    const timeOutFunctcheckStaticticalChecking = (reqInfo) => {
        chekcRef.current = false;
        // toast.error(t('error.time_out'));
    };

    const handleBeforeUnload = (event) => {
        event.preventDefault();
        event.returnValue = '';
    };

    // region openCellResult
    const openCellResult = (reqInfoMap, message) => {
        console.log('reqInfoMap', reqInfoMap['input_param']);

        setActionDeviceOnline(false);
        actionRef.current = false;
        if ((message['proc_status']?.toString() || '0') === '0') {
            // closeCell();
            openRef.current = false;
            toast.error('Error: ' + message['proc_message']);
        } else {
            openRef.current = true;
            handleActionDevice();

            // gọi api kiểm tra trạng thái ô sau 5s
            const input_param = reqInfoMap['input_param'];
            handleIntervalCheckStatusCell(input_param[0], input_param[1], input_param[2]);
        }
    };

    const timeOutFunctIOT = (reqInfo) => {
        setActionDeviceOnline(false);
        actionRef.current = false;
        toast.error(t('error.time_out') + ' IOT');
        // closeCell();
    };

    // region closeCell
    const closeCell = () => {
        openRef.current = false;
        let service = serviceList.closeCellIOT;
        let inpuVal = [device?.cabinet_cd, device?.drawer_lc, device?.cell_lc.row, device?.cell_lc.column];
        clearIntervalCheckStatusCell();
        if (device?.cabinet_type !== 'round') {
            service = serviceList.closeCellIOT;
            inpuVal = [device.cabinet_cd, device.drawer_lc, device.cell_lc.row, device.cell_lc.column];
        } else {
            service = serviceList.closeCellIOTCabinetV2;
            inpuVal = [device.cabinet_cd, device.drawer_lc, device.cell_lc.column, device.column];
        }
        sendRequest(service, inpuVal, closeCellResult, true, timeOutFunctIOT, 10000, 0);
        // console.log('inpuValClose: ', inpuVal);
        // console.log('serviceListClose: ', service);
    };

    // region closeCellResult
    const closeCellResult = (reqInfoMap, message) => {
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
        } else {
            setVisibleConfirm(false);
            setIsOpen(false);
        }
        clearIntervalCheckStatusCell();
    };

    // region handleActionDevice
    const handleActionDevice = () => {
        if (actionRef.current || flagActionDeviceRef.current) return;
        if (bussiness === 'ebr' && +dayGive <= 0) return toast.error(t('err_day_give'));

        setActionDeviceOnline(true);
        setFlagActionDevice(true);
        flagActionDeviceRef.current = true;
        actionRef.current = true;
        // return;
        const InVal = [
            idDeviceRequests,
            note,
            bussiness === 'etk' ? '' : moment().add(+dayGive, 'days').format('YYYYMMDD'),
        ];
        sendRequest(
            serviceList.getDeviceRequestDevice,
            InVal,
            actionDeviceResult,
            true,
            timeOutFunctActionDevice,
            15000
        );
    };

    // region actionDeviceResult
    const actionDeviceResult = (reqInfoMap, message) => {
        setActionDeviceOnline(false);
        actionRef.current = false;
        //
        setFlagActionDevice(false);
        flagActionDeviceRef.current = false;
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            closeCell();
            return;
        } else {
            toast.success(message['proc_message']);
            // setOpen(false);
            // closeCell();
            setIsOpen(true);
            getData && getData();
            glb_sv.commonEvent.next({ type: eventList.ADD_NOTIFY, data: true });

            glb_sv.commonEvent.next({ type: eventList.ADD_PRODUCT, data: 'add' });
            sendEmailDevice();
        }
    };

    const timeOutFunctActionDevice = (reqInfo) => {
        setActionDeviceOnline(false);
        actionRef.current = false;
        setFlagActionDevice(false);
        flagActionDeviceRef.current = false;
        setOpen(false)
        getData()
        toast.error(t('error.time_out'));
    };

    // region sendEmailDevice
    const sendEmailDevice = () => {
        if (sendEmailRef.current) return;
        setSendEmail(true);
        sendEmailRef.current = true;

        let InVal = [device.device_id, device.cell_id];
        sendRequest(serviceList.sendEmailDevice, InVal, sendEmailDeviceResult, true, timeOutFunctSendEmail, 15000);
    };
    // region sendEmailDeviceResult
    const sendEmailDeviceResult = (reqInfoMap, message) => {
        setSendEmail(false);
        sendEmailRef.current = false;
        if ((message['proc_status']?.toString() || '0') === '0') {
            return;
        } else {
            // console.log('Gửi thành công')
            return;
        }
    };

    const timeOutFunctSendEmail = (reqInfo) => {
        setSendEmail(false);
        sendEmailRef.current = false;
    };
    // region checkLocationDevice
    const checkLocationDevice = (data) => {
        if (actionRef.current) return;
        actionRef.current = true;
        const chooseCabinetLocal = glb_sv.getLocalStorageCabinet('cabinet');
        const InVal = [
            data.cell_id,
            chooseCabinetLocal?.id || 0, // ID Tủ hiện tại
        ];
        sendRequest(
            serviceList.checkLocationDevice,
            InVal,
            checkLocationDeviceResult,
            true,
            timeOutFunctcheckLocationDevice,
            15000
        );
    };

    const checkLocationDeviceResult = (reqInfoMap, message) => {
        actionRef.current = false;
        if ((message['proc_status']?.toString() || '0') === '0') {
            setIsOpenNotification(true);
            setDataNotification(message['proc_data']?.rows[0]?.o_1[0]);
            return;
        } else {
            openCell(device);
        }
    };

    const timeOutFunctcheckLocationDevice = (reqInfo) => {
        actionRef.current = false;
        toast.error(t('error.time_out'));
    };

    // region checkStatusCell START
    const checkIntervalCheckStatusCell = useRef(null);
    const checkStatusCellFlag = useRef(false);
    const handleIntervalCheckStatusCell = (cabinet_cd, drawer_id, cell_address) => {
        checkIntervalCheckStatusCell.current = setInterval(() => {
            checkStatusCell(cabinet_cd, drawer_id, cell_address);
        }, 3000);
    };
    const clearIntervalCheckStatusCell = () => {
        console.log('checkIntervalCheckStatusCell.current', checkIntervalCheckStatusCell.current);
        clearInterval(checkIntervalCheckStatusCell.current);
    };
    const checkStatusCell = (cabinet_cd, drawer_id, cell_address) => {
        console.log('checkIntervalCheckStatusCell.current', checkIntervalCheckStatusCell.current);
        if (!cabinet_cd || !drawer_id || !cell_address || checkStatusCellFlag.current) return;
        checkStatusCellFlag.current = true;
        const inpuVal = [cabinet_cd, drawer_id, cell_address];
        sendRequest(
            serviceList.checkStatusCell,
            inpuVal,
            checkStatusCellResult,
            true,
            checkStatusCellTimeOut,
            10000,
            0
        );
    };
    const checkStatusCellResult = (reqInfoMap, message) => {
        checkStatusCellFlag.current = false;
        console.log(
            'checkStatusCellResult',
            (message['proc_code']?.toString() || '1') === '1' && (message['proc_status']?.toString() || '1') === '1'
        );
        if ((message['proc_code']?.toString() || '1') === '1' && (message['proc_status']?.toString() || '1') === '1') {
            closeCell();
            setOpen(false);
            setIsOpen(false);
        }
    };
    const checkStatusCellTimeOut = (reqInfo) => {
        checkStatusCellFlag.current = false;
    };
    // region checkStatusCell END
    return (
        <>
            <NotificationWarnLocationDeviceModal
                visible={isOpenNotification}
                setVisible={setIsOpenNotification}
                title={t('notification_warning')}
                data={dataNotification}
            />
            <ConfirmDeviceModal
                visible={visibleConfirm}
                setVisible={setVisibleConfirm}
                title={t('confirm')}
                handleSave={closeCell}
            />
            <Loader loading={actionDeviceOnline || flagActionDevice} />
            <Drawer
                anchor="right"
                open={open}
                PaperProps={{
                    sx: {
                        width: { sm: '100%', md: 500 },
                        border: 'none',
                        overflow: 'hidden',
                    },
                }}
            >
                <Stack direction="row" alignItems="center" justifyContent="left" sx={{ px: 1, py: 2 }}>
                    <Typography variant="subtitle1" sx={{ ml: 1 }}>
                        {t('confirm_info')}
                    </Typography>
                </Stack>

                <Divider />

                {/* <Scrollbar> */}
                <Stack spacing={3} sx={{ p: 3, maxHeight: '100%', overflowY: 'scroll' }} className="srcoll-test">
                    {/* Cảnh báo khi hệ thông đang kiểm kê */}
                    {isChecked && (
                        <Alert sx={{ alignItems: 'flex-start' }} severity="error" style={{ marginBottom: '20px' }}>
                            <div>
                                <Typography fontWeight="lg" sx={{ fontWeight: '600', fontSize: '17px' }} mt={0.25}>
                                    {t('warning')}
                                </Typography>
                                <Typography fontSize="sm" sx={{ opacity: 0.8 }}>
                                    {t('system_statistical')}, {t('not_action_transaction')}
                                </Typography>
                            </div>
                        </Alert>
                    )}

                    {/* Cảnh báo khi số lượng mượn vượt quá số lượng trong kho */}
                    {device?.qty > device.cell_qty ? (
                        <Alert sx={{ alignItems: 'flex-start' }} severity="warning" style={{ marginBottom: '20px' }}>
                            <div>
                                <Typography fontWeight="lg" sx={{ fontWeight: '600', fontSize: '17px' }} mt={0.25}>
                                    {t('warning')}
                                </Typography>
                                <Typography fontSize="sm" sx={{ opacity: 0.8 }}>
                                    {t('warning_qty')}{' '}
                                    <b>
                                        {device?.qty}/{device?.cell_qty}
                                    </b>
                                </Typography>
                            </div>
                        </Alert>
                    ) : (
                        ''
                    )}

                    {/* Nếu nghiệp vụ trả thì ẩn input ngày trả và ngược lại */}
                    {!isOpen ? (
                        <>
                            <TextInput
                                label={t('note_')}
                                getValue={setNote}
                                valueChange={note}
                                onEnterPress={() => {
                                    openCell(device);
                                }}
                                size="medium"
                                required
                                disabled
                            />
                            {bussiness === 'ebr' ? (
                                <NumberInput
                                    label={t('number_day_give')}
                                    getValue={setDayGive}
                                    valueChange={dayGive}
                                    onEnterPress={() => {
                                        openCell(device);
                                    }}
                                    size="medium"
                                    required
                                    autoFocus
                                />
                            ) : (
                                ''
                            )}
                        </>
                    ) : (
                        <Alert sx={{ alignItems: 'flex-start' }} severity="warning" style={{ marginBottom: '20px' }}>
                            {/* nếu trạng thái ô đang mở thì cảnh báo */}
                            <div>
                                <Typography fontWeight="lg" sx={{ fontWeight: '600', fontSize: '17px' }} mt={0.25}>
                                    {t('note')}
                                </Typography>
                                <Typography fontSize="sm" sx={{ opacity: 0.8 }}>
                                    {t('modal_confirm')}
                                    <b> {t('modal_tt')} </b>
                                    {t('thanks_modal')}
                                </Typography>
                            </div>
                        </Alert>
                    )}
                    <Stack direction="row" sx={{ px: 1, py: 1 }}>
                        <img
                            style={{
                                width: '150px',
                                height: '150px',
                                borderRadius: '5px',
                                backgroundColor: '#999',
                            }}
                            src={
                                device?.img_device
                                    ? `${glb_sv.urlGetProductImage(device?.img_device)}`
                                    : `${glb_sv.urlGetProductImage(device?.pic_device)}`
                            }
                            alt=""
                        />
                        <Stack spacing={0.5} sx={{ pl: 1.5 }}>
                            <Typography variant="subtitle1" sx={{ color: 'text.primary' }}>
                                {glb_sv.convertMultipleLanguages(device?.device_nm)}
                            </Typography>{' '}
                            <Typography variant="subtitle2" sx={{ color: 'text.secondary' }}>
                                {t('cabinet')}: {device?.cabinet_nm}
                            </Typography>
                            {/* <Typography variant="subtitle2" sx={{ color: 'text.secondary' }}>
                                    {t('cabinet')}: {device?.cabinet_nm}
                                </Typography> */}
                            <Stack
                                display={'flex'}
                                flexDirection={'row'}
                                flexWrap={'wrap'}
                                gap={2}
                                justifyContent={'space-between'}
                            >
                                <Typography variant="subtitle2" sx={{ color: 'text.secondary' }}>
                                    {t('drawer')}: {device?.drawer_nm}
                                </Typography>
                                {device?.cabinet_type === 'round' ? (
                                    <Typography variant="subtitle2" sx={{ color: 'text.secondary' }}>
                                        {t('ordinal_number')}: {device?.cell_lc?.column}
                                    </Typography>
                                ) : (
                                    <Typography variant="subtitle2" sx={{ color: 'text.secondary' }} noWrap>
                                        {t('cell')}: {`[ ${device?.cell_lc?.row} : ${device?.cell_lc?.column} ]`}
                                    </Typography>
                                )}
                            </Stack>
                            <Typography variant="subtitle2" sx={{ color: 'text.secondary' }}>
                                {t('property')}:{' '}
                                {device?.properties_device?.length > 0 &&
                                    device?.properties_device.map((values) => {
                                        let str = '';
                                        str +=
                                            glb_sv.convertMultipleLanguages(values.label) +
                                            ': ' +
                                            glb_sv.convertMultipleLanguages(values.value) +
                                            ', ';
                                        return str;
                                    })}
                            </Typography>
                            <Stack
                                display={'flex'}
                                flexWrap={'wrap'}
                                gap={2}
                                flexDirection={'row'}
                                justifyContent={'space-between'}
                            >
                                <Typography variant="subtitle2" sx={{ color: 'text.secondary' }}>
                                    {t('quantity_category')}: {device?.qty}
                                </Typography>
                                <Typography variant="subtitle2" sx={{ color: 'text.secondary' }} noWrap>
                                    {t('store')}: {device?.cell_qty}
                                </Typography>
                            </Stack>
                        </Stack>
                    </Stack>
                    {device?.cabinet_type && (
                        <ChessBoard
                            rows={device?.row}
                            columns={device?.column}
                            activePosition={{
                                row: device?.cell_lc?.row ? device.cell_lc.row : 1,
                                column: device?.cell_lc?.column ? device.cell_lc.column : 1,
                            }}
                            typeCabinet={device?.cabinet_type}
                        />
                    )}
                </Stack>
                {/* </Scrollbar> */}

                <Box sx={{ p: 3, display: 'flex', justifyContent: 'space-between', gap: 1 }}>
                    {!isOpen && (
                        <ButtonAction
                            type="cancel"
                            size="large"
                            title={t('cancel')}
                            onClick={() => {
                                setOpen(false);
                            }}
                        />
                    )}
                    <>
                        {!isOpen ? (
                            <ButtonAction
                                type="confirm"
                                disabled={+device?.cell_qty < +device?.qty || isChecked ? true : false}
                                size="large"
                                title={
                                    device?.bussiness === 'etk'
                                        ? t('comfirm') + ' ' + t('take')
                                        : t('comfirm') + ' ' + t('borrowing')
                                }
                                onClick={() => {
                                    checkLocationDevice(device);
                                }}
                            />
                        ) : (
                            <Button
                                fullWidth
                                variant="outlined"
                                disabled={isChecked ? true : false}
                                onClick={() => {
                                    closeCell();
                                    setOpen(false);
                                    setIsOpen(false);
                                }}
                                size="large"
                                startIcon={<Iconify icon="material-symbols:check-circle" />}
                            >
                                {t('confrim_success')}
                            </Button>
                        )}
                    </>
                </Box>
            </Drawer>
        </>
    );
}
